'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@achra/ui/button';
import { cn } from '@achra/ui/lib/utils';
import { LifeBuoy } from 'lucide-react';
import { SUPPORT_DISCORD_URL } from '@/modules/onboarding/lib/constants';
interface SupportCalloutProps {
  className?: string;
}
function SupportCallout(t0) {
  const $ = _c(7);
  const {
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex flex-col items-start gap-3", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="text-muted-foreground flex size-9 items-center justify-center rounded-full border"><LifeBuoy className="size-4" aria-hidden="true" /></span>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex flex-col gap-1"><p className="text-sm font-semibold">Having trouble?</p><p className="text-muted-foreground text-sm">Feel free to contact us and we'll always help you through the process.</p></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Button variant="outline" size="sm" asChild={true}><a href={SUPPORT_DISCORD_URL} target="_blank" rel="noopener noreferrer">Contact us</a></Button>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t1) {
    t5 = <div className={t1}>{t2}{t3}{t4}</div>;
    $[5] = t1;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}
export { SupportCallout };